<!-- version 2021/05/20 -->
<template>
    <a :href="link">{{ text }}</a>
</template>

<script>
    export default {
        props: {
            text: String,
            link: String
        }
    }
</script>

<style lang="sass" scoped>
    a
        color: #28c3cd
</style>